export default {"src":"/_next/static/media/circle_flag2.349afb98.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};